module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showNav) ? _c('div', {
    staticClass: "header-nav"
  }, [_c('custom-components', {
    attrs: {
      "place": "nav:start"
    }
  }), _vm._v(" "), (_vm.hasNav) ? _c('ul', {
    staticClass: "nav-list"
  }, _vm._l((_vm.currentNav), function(navItem, index) {
    return _c('li', {
      staticClass: "nav-item"
    }, [(navItem.type === 'dropdown') ? _c('div', {
      staticClass: "nav-item-dropdown",
      attrs: {
        "onClick": "return true"
      }
    }, [_vm._v("\n        " + _vm._s(_vm.getTitle(navItem)) + "\n        "), _c('span', {
      staticClass: "arrow"
    }), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-list"
    }, _vm._l((navItem.items), function(subItem) {
      return _c('li', {
        staticClass: "dropdown-item",
        style: ({
          padding: subItem.type === 'sep' ? '0' : '0 20px'
        })
      }, [(subItem.type === 'sep') ? _c('span', {
        staticClass: "sep"
      }) : (subItem.type === 'label') ? _c('span', {
        staticClass: "label"
      }, [_vm._v(_vm._s(subItem.title))]) : _c('nav-link', {
        attrs: {
          "item": subItem
        }
      })], 1)
    }))]) : _c('nav-link', {
      attrs: {
        "item": navItem
      }
    })], 1)
  })) : _vm._e(), _vm._v(" "), _c('custom-components', {
    attrs: {
      "place": "nav:end"
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-e1b43aaa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeaderNav.vue
// module id = 108
// module chunks = 0